import { BrandSprite } from '@/components/brand/BrandSprite'
import { MotionProvider } from '@/components/motion/MotionProvider'
import { SeoHead } from '@/components/seo/SeoHead'
import { pageTitle } from '@/lib/seo'
import { NominationFooter } from '@/nominations/components/NominationFooter'
import { NominationHero } from '@/nominations/components/NominationHero'
import { NominationResponsePanel } from '@/nominations/components/NominationResponsePanel'
import { NominationTopBar } from '@/nominations/components/NominationTopBar'
import { RoomSection } from '@/nominations/components/RoomSection'
import type { NominationConfig } from '@/nominations/types'

type NominationPageProps = {
  nomination: NominationConfig
}

/**
 * Standalone nomination page in the site's design, but outside the site shell (no site nav or
 * footer). Always `noindex`, and never linked from public navigation or the sitemap.
 */
export const NominationPage = ({ nomination }: NominationPageProps) => {
  const idBase = `nomination-${nomination.slug}`

  return (
    <MotionProvider>
      <SeoHead
        title={pageTitle(nomination.seo.title)}
        description={nomination.seo.description}
        canonicalPath={nomination.path}
        noindex
      />

      <div className="site nom">
        <BrandSprite />
        <NominationTopBar number={nomination.number} />
        <main id="main">
          <NominationHero nomination={nomination} titleId={`${idBase}-title`} />
          <RoomSection titleId={`${idBase}-room-title`} />
          <NominationResponsePanel nomination={nomination} titleId={`${idBase}-response-title`} />
        </main>
        <NominationFooter nomination={nomination} />
      </div>
    </MotionProvider>
  )
}
